import React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import mobileFeatureFlagDescriptionImg from "../../../assets/images/featureFlag/feature_flag_description_mobile.png"
import FeatureFlagDescriptionImg from "../../../assets/images/featureFlag/feature_flag_description.png"
import mobileFeatureFlagDescriptionImgEn from "../../../assets/images/featureFlag/feature_flag_description_mobile_en.png"
import FeatureFlagDescriptionImgEn from "../../../assets/images/featureFlag/feature_flag_description_en.png"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      [theme.breakpoints.up("md")]: {},
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function FeatureFlagDescription() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {lang === "ko" ? (
          <img src={isMobile ? mobileFeatureFlagDescriptionImg : FeatureFlagDescriptionImg} />
        ) : (
          <img src={isMobile ? mobileFeatureFlagDescriptionImgEn : FeatureFlagDescriptionImgEn} />
        )}
      </div>
    </div>
  )
}
